<script>
import { defineComponent } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    components: {
        'the-button': TheButton,
        loader: Loader,
    },
    props: {
        orderId: {
            type: Number,
            default: null,
        },
        address: {
            type: String,
            default: null,
        },
        addressLoading: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'save'],
    setup(props, { emit }) {
        const emitCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const emitSave = () => {
            if (props.loading) return
            emit('save')
        }

        return { emitCancel, emitSave }
    },
})
</script>

<template>
    <div class="SetAddressPanel">
        <p class="select-none">
            Назначение адреса заказу: <b>{{ orderId }} (ID)</b>
        </p>

        <template v-if="addressLoading">
            <div class="flex flex-col items-center justify-center mt-3">
                <loader class="primary" />
                <span class="select-none mt-1 text-sm text-gray-400">Геокодирование адреса...</span>
            </div>
        </template>

        <template v-else-if="Boolean(address)">
            <div class="mt-3 py-3 border-b border-t">
                <p class="text-gray-400">Указанный адрес</p>
                <p class="">{{ address }}</p>
            </div>
        </template>

        <p v-else class="py-3 mt-3 text-gray-400 border-t border-b text-center select-none">
            Для того, чтобы установить адрес заказу, нажмите на соотвествующую область на карте
        </p>

        <div class="flex items-center justify-between mt-3">
            <the-button class="second text small" :disabled="loading" @click="emitCancel">
                <i class="fas fa-times mr-2" /> Отмена
            </the-button>

            <the-button
                class="primary text small ml-3"
                :disabled="loading || addressLoading || !Boolean(address)"
                :loading="loading"
                @click="emitSave"
            >
                <i class="fas fa-check mr-2" /> Сохранить
            </the-button>
        </div>
    </div>
</template>

<style lang="scss" scoped src="./index.scss" />
